import { withProps } from 'recompose';

import StackedLayout from 'app/components/layout/StackedLayout';

const BlockWrapper = withProps({ isContained: true })(
  StackedLayout.ContentBlock,
);

export default BlockWrapper;
